let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ad62t")).then(() => parcelRequire('5UIzc'));